import { AxiosError } from "axios";
import { Menus } from "../../../components/Menu/idex";
import { api } from "../../../Api/ApiService";
import { useEffect, useState } from "react";
import { Container } from "./styles";
import gato from "../../../assets/gato.svg";
import cachorro from "../../../assets/cachorro.svg";

interface IInforQuantidade {
  quantidade_disponivel: string;
  quantidade_adotado: string;
  total: string;
}

const Relatorios = () => {
  const [quantidades, setQuantidades] = useState<IInforQuantidade[]>([]);
  const [quantidadesGato, setQuantidadesGato] = useState<IInforQuantidade[]>(
    []
  );
  const [quantidadesCachorro, setQuantidadesCachorro] = useState<
    IInforQuantidade[]
  >([]);

  async function getAnimais() {
    try {
      const resul = await api.get(
        `/animais?token=${process.env.REACT_APP_TOKEN_API}`
      );

      const qnt_disponivel = await resul.data.filter(
        (item: any) => item.data.disponivel === true
      );
      const qnt_adotado = await resul.data.filter(
        (item: any) => item.data.disponivel === false
      );
      const qnt_disp_gato = await resul.data.filter(
        (item: any) =>
          item.data.disponivel === true && item.data.tipo === "Gato"
      );
      const qnt_adot_gato = await resul.data.filter(
        (item: any) =>
          item.data.disponivel === false && item.data.tipo === "Gato"
      );
      const qnt_disp_cachorro = await resul.data.filter(
        (item: any) =>
          item.data.disponivel === true && item.data.tipo === "Cachorro"
      );
      const qnt_adot_cachorro = await resul.data.filter(
        (item: any) =>
          item.data.disponivel === false && item.data.tipo === "Cachorro"
      );

      let res_quantidade: IInforQuantidade[] = [];
      res_quantidade.push({
        quantidade_disponivel: qnt_disponivel.length,
        quantidade_adotado: qnt_adotado.length,
        total: qnt_disponivel.length + qnt_adotado.length,
      });
      setQuantidades(res_quantidade);

      let res_quantidade_gato: IInforQuantidade[] = [];
      res_quantidade_gato.push({
        quantidade_disponivel: qnt_disp_gato.length,
        quantidade_adotado: qnt_adot_gato.length,
        total: qnt_disp_gato.length + qnt_adot_gato.length,
      });
      setQuantidadesGato(res_quantidade_gato);

      let res_quantidade_cachorro: IInforQuantidade[] = [];
      res_quantidade_cachorro.push({
        quantidade_disponivel: qnt_disp_cachorro.length,
        quantidade_adotado: qnt_adot_cachorro.length,
        total: qnt_disp_cachorro.length + qnt_adot_cachorro.length,
      });
      setQuantidadesCachorro(res_quantidade_cachorro);
    } catch (error: AxiosError | any) {
      console.log(error);
    }
  }

  useEffect(() => {
    getAnimais();
  }, []);

  // useEffect(() => {
  //   console.log(inforAnimal)
  // }, [inforAnimal]);

  return (
    <>
      <Menus />
      <Container>
        <div className="title">
          <h1>ESTATÍSTICAS</h1>
        </div>

        <div className="container">
          {quantidades.length > 0 ? (
            <>
              {quantidades.map((item) => {
                return (
                  <>
                    <div className="linha">
                      <span>Animais disponíveis para adoção</span>
                      <span>{item.quantidade_disponivel}</span>
                    </div>
                    <div className="linha">
                      <span>Animais adotados</span>
                      <span>{item.quantidade_adotado}</span>
                    </div>
                    <div className="linha-total">
                      <span>TOTAL</span>
                      <span>{item.total}</span>
                    </div>
                  </>
                );
              })}
            </>
          ) : (
            <>
              <div className="linha">
                <span>Animais disponíveis para adoção</span>
                <span>0</span>
              </div>
              <div className="linha">
                <span>Animais adotados</span>
                <span>0</span>
              </div>
              <div className="linha-total">
                <span>TOTAL</span>
                <span>0</span>
              </div>
            </>
          )}
        </div>

        <div className="box">
          <div className="dog">
            <img className="img-dog" src={cachorro} />
            {quantidadesCachorro.length > 0 ? (
              <>
                {quantidadesCachorro.map((item) => {
                  return (
                    <>
                      <div className="linha">
                        <span>Cachorros disponíveis para adoção</span>
                        <span>{item.quantidade_disponivel}</span>
                      </div>
                      <div className="linha">
                        <span>Cachorros adotados</span>
                        <span>{item.quantidade_adotado}</span>
                      </div>
                      <div className="linha-total">
                        <span>TOTAL</span>
                        <span>{item.total}</span>
                      </div>
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <div className="linha">
                  <span>Cachorros disponíveis para adoção</span>
                  <span>0</span>
                </div>
                <div className="linha">
                  <span>Cachorros adotados</span>
                  <span>0</span>
                </div>
                <div className="linha-total">
                  <span>TOTAL</span>
                  <span>0</span>
                </div>
              </>
            )}
          </div>

          <div className="cat">
            <img className="img-cat" src={gato} />
            {quantidadesGato.length > 0 ? (
              <>
                {quantidadesGato.map((item) => {
                  return (
                    <>
                      <div className="linha">
                        <span>Gatos disponíveis para adoção</span>
                        <span>{item.quantidade_disponivel}</span>
                      </div>
                      <div className="linha">
                        <span>Gatos adotados</span>
                        <span>{item.quantidade_adotado}</span>
                      </div>
                      <div className="linha-total">
                        <span>TOTAL</span>
                        <span>{item.total}</span>
                      </div>
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <div className="linha">
                  <span>Gatos disponíveis para adoção</span>
                  <span>0</span>
                </div>
                <div className="linha">
                  <span>Gatos adotados</span>
                  <span>0</span>
                </div>
                <div className="linha-total">
                  <span>TOTAL</span>
                  <span>0</span>
                </div>
              </>
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

export { Relatorios };
